import React, { useState } from 'react';
import { Button, ModalBody, ModalFooter, ModalHeader } from '@nextui-org/react';
import { SettingsService } from '../../../../services';
import toast from 'react-hot-toast';

const ModalDelete = ({ item, onClose, onSuccess }) => {
  const { isLoading, onSubmit } = useForm(item, onSuccess);

  return (
    <>
      <ModalHeader className="flex flex-col gap-1">Confirmación</ModalHeader>
      <ModalBody>
        <p className="text-center">¿Estás seguro de eliminar esta cuenta de pago?</p>
        <p className="text-center font-medium">{ item?.name }</p>
      </ModalBody>
      <ModalFooter className="justify-evenly">
        <Button variant="light" onPress={onClose} isLoading={isLoading}>Cancelar</Button>
        <Button color="danger" onPress={onSubmit} isLoading={isLoading}>Aceptar</Button>
      </ModalFooter>
    </>
  )
}

const useForm = (item, onSuccess) => {
  const [isLoading, setIsLoading] = useState(false);

  const onSubmit = async () => {
    setIsLoading(true);

    try {
      await SettingsService.admin.removePaymentMethodInfo(item);
      toast.success('Cuenta eliminada correctamente');
      onSuccess();

    } catch (error) {
      //
    }

    setIsLoading(false);
  }

  return {
    isLoading,
    onSubmit,
  }
}

export default ModalDelete